module.exports = __webpack_public_path__ + "static/38gde-4a6f7be9efd0660841e81fc9a861e7b7.gif";